document.addEventListener('DOMContentLoaded', function() {
  /*
    const menuItems = document.querySelectorAll('.mega-menu__list li');
    const productContainer = document.querySelector('.mega-menu__products');
  
    // Inicializar el primer <a> en bold
    if (menuItems.length > 0) {
      const firstLink = menuItems[0].querySelector('a');
      if (firstLink) {
        firstLink.style.fontWeight = 'bold';
        firstLink.style.color = '#000';
      }
    }
  
    menuItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        const productIds = item.getAttribute('data-products').split(',');
        const link = item.querySelector('a');
  
        // Ocultar todos los productos
        productContainer.querySelectorAll('.mega-menu__product').forEach(product => {
          product.style.display = 'none';
        });
  
        // Mostrar los productos correspondientes
        productIds.forEach(id => {
          const product = productContainer.querySelector(`[data-product-id="${id}"]`);
          if (product) {
            product.style.display = 'block';
          }
        });
  
        // Remover negritas de todos los <a> dentro de los <li>
        menuItems.forEach(el => {
          const linkEl = el.querySelector('a');
          if (linkEl) {
            linkEl.style.fontWeight = 'normal';
            linkEl.style.color = '#121212bf';
          }
        });
  
        // Poner en negritas el <a> del item actual
        if (link) {
          link.style.fontWeight = 'bold';
          link.style.color = '#000';
        }
      });
    });
  */
});
  